import { useCHBCatalogRelations } from '@/hooks/PDP/usePublicationCatalogRelations';
import EcommPanelPublicationContent, {
  EcommPanelPublicationContentProps
} from './EcommPanelPublicationContent';
import { useEffect } from 'react';

type EcommPanelCourseHandbookProps = Omit<
  EcommPanelPublicationContentProps,
  'catalogRelations' | 'libraryRelations'
>;

const EcommPanelCourseHandbook = ({
  isLoadingContent,
  content,
  params,
  onClose,
  context,
  itemListAnalyticsModel
}: EcommPanelCourseHandbookProps) => {
  const catalogRelations = useCHBCatalogRelations(content);

  useEffect(() => {
    if (catalogRelations?.isError) throw Error;
  }, [catalogRelations.isError]);

  return (
    <EcommPanelPublicationContent
      isLoadingContent={isLoadingContent}
      content={content}
      params={params}
      catalogRelations={catalogRelations}
      onClose={onClose}
      context={context}
      itemListAnalyticsModel={itemListAnalyticsModel}
    />
  );
};

export default EcommPanelCourseHandbook;
